import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import DatatableExpand from "../../Constants/DatatableExpand";
import { Row, Col, Label, Container } from "reactstrap";
import { COLUMNS_GRADES_ACONSEJERIA, EXPAND_ROW_GRADE_ACONSEJERIA } from "../../Constants/DatatableColumns";
import { AdminAConsejeria } from "./../../Constants/Modal";
import {validateTokenStorage} from './../../Constants/Util';
import moment from "moment";
import {
  getGrades,
  getTeacherAconsejeria,
  getTeachers,
  putChangeAconsejeria,
  postNewConsejeria,
} from "../../Constants/Services";
import { ITeacherAConsejeria, ITeachers, IGrades, IGradeSelected } from "./../../Constants/Interfaces";

interface IAconsejeriaState {
  dataTeacherAConsejeria: ITeacherAConsejeria[];
  dataTeacherAConsejeriaSelected: ITeacherAConsejeria;
  dataTeachers: ITeachers[];
  dataGrades: IGrades[];
  dataGradeSelected: IGradeSelected;
  isOpenModalAddAConsejeria: boolean;
  isOpenModalEditAConsejeria: boolean;
  year: string;
}

class AConsejeria extends Component<RouteComponentProps<{}>, IAconsejeriaState> {
  constructor(props: any) {
    super(props);
    this.state = {
      dataTeacherAConsejeria: [],
      dataTeacherAConsejeriaSelected: {
        grc_id: "",
        per_id: "",
        per_name: "",
        per_lastname: "",
      },
      dataTeachers: [],
      dataGrades: [],
      dataGradeSelected: {
        gr_id: "",
        gr_desc: "",
      },
      isOpenModalAddAConsejeria: false,
      isOpenModalEditAConsejeria: false,
      year: moment(new Date().toString()).format("YYYY"),
    };

    this.fetchGrade = this.fetchGrade.bind(this);
    this.fetchTeacherAconsejeria = this.fetchTeacherAconsejeria.bind(this);
    this.fetchTeachers = this.fetchTeachers.bind(this);
    this.handlerModalAddAConsejeria = this.handlerModalAddAConsejeria.bind(this);
    this.handlerPostConsejeria = this.handlerPostConsejeria.bind(this);
    this.handlerPutConsejeria = this.handlerPutConsejeria.bind(this);
    this.setTeacher = this.setTeacher.bind(this);
    this.handlerModalEditAConsejeria = this.handlerModalEditAConsejeria.bind(this);
  }

  async fetchTeacherAconsejeria({ gr_id, gr_desc }: IGradeSelected) {
    const response = await getTeacherAconsejeria(gr_id);
    this.setState({
      dataTeacherAConsejeria: response,
      dataGradeSelected: { gr_id, gr_desc },
    });
  }

  async fetchGrade() {
    const response = await getGrades();
    this.setState({
      dataGrades: response,
    });
  }

  async fetchTeachers() {
    const response = await getTeachers();
    this.setState({
      dataTeachers: response,
    });
  }

  componentDidMount() {
    if(validateTokenStorage()){
      this.context.quitToken();
    }
    this.fetchTeachers();
    this.fetchGrade();
  }

  handlerModalEditAConsejeria(row: ITeacherAConsejeria) {
    this.setState((prevState) => ({
      isOpenModalEditAConsejeria: !prevState.isOpenModalEditAConsejeria,
      dataTeacherAConsejeriaSelected: row,
    }));
  }

  handlerModalAddAConsejeria() {
    this.setState((prevState) => ({
      isOpenModalAddAConsejeria: !prevState.isOpenModalAddAConsejeria,
      dataTeacherAConsejeriaSelected: {
        grc_id: "",
        per_id: "",
        per_name: "",
        per_lastname: "",
      },
    }));
  }

  handlerPutConsejeria() {
    const props = this.state.dataTeacherAConsejeriaSelected;
    const propsGrade = this.state.dataGradeSelected;
    const body = {
      per_id: props.per_id,
      grc_id: props.grc_id,
    };

    putChangeAconsejeria(body);
    this.setState({ isOpenModalEditAConsejeria: false });

    setTimeout(() => {
      this.fetchTeacherAconsejeria({ gr_id: propsGrade.gr_id, gr_desc: propsGrade.gr_desc });
    }, 1000);
  }

  handlerPostConsejeria() {
    const props = this.state.dataTeacherAConsejeriaSelected;
    const propsGrade = this.state.dataGradeSelected;
    const body = {
      per_id: props.per_id,
      gr_id: propsGrade.gr_id,
    };

    postNewConsejeria(body);
    this.setState({ isOpenModalAddAConsejeria: false });

    setTimeout(() => {
      this.fetchTeacherAconsejeria({ gr_id: propsGrade.gr_id, gr_desc: propsGrade.gr_desc });
      this.fetchTeachers();
    }, 1000);
  }

  setTeacher = ({ per_id, per_name, per_lastname }: ITeacherAConsejeria) => {
    this.setState({
      dataTeacherAConsejeriaSelected: {
        ...this.state.dataTeacherAConsejeriaSelected,
        per_id,
        per_name,
        per_lastname,
      },
    });
  };
  render() {
    const props = this.state;
    return (
      <React.Fragment>
        {props.isOpenModalAddAConsejeria && (
          <AdminAConsejeria
            title="Agregar consejeria"
            dataTeacherSelected={props.dataTeacherAConsejeriaSelected}
            dataTeacher={props.dataTeachers}
            isOpen={props.isOpenModalAddAConsejeria}
            toggle={this.handlerModalAddAConsejeria}
            toggleSave={this.handlerPostConsejeria}
            setTeacher={this.setTeacher}
          />
        )}

        {props.isOpenModalEditAConsejeria && (
          <AdminAConsejeria
            title="Cambiar consejeria"
            dataTeacherSelected={props.dataTeacherAConsejeriaSelected}
            dataTeacher={props.dataTeachers}
            isOpen={props.isOpenModalEditAConsejeria}
            toggle={this.handlerModalEditAConsejeria}
            toggleSave={this.handlerPutConsejeria}
            setTeacher={this.setTeacher}
          />
        )}

        <Container className="mt-4">
          <Row>
            <Col sm={12} className="text-center">
              <Label className="font-weight-bold">
                <h3>Asignar consejeria</h3>
              </Label>
            </Col>
            <Col sm={12}>
              <DatatableExpand
                data={props.dataGrades}
                columns={COLUMNS_GRADES_ACONSEJERIA()}
                keyProp="gr_id"
                expandRow={EXPAND_ROW_GRADE_ACONSEJERIA(
                  props.dataTeacherAConsejeria,
                  this.fetchTeacherAconsejeria,
                  this.handlerModalEditAConsejeria,
                  this.handlerModalAddAConsejeria
                )}
                exportD={false}
                searchs={false}
              />
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}
export default AConsejeria;
